document.addEventListener("DOMContentLoaded", function() {

    // swiper výpis nemovitostí
    //=========================
    (function () {
        let swiperSelector = document.querySelectorAll('.nemovitosti-foto.JS-swiper-nemovitosti-foto');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        swiperSelector.forEach(el => {
            let swiperNemovitostiFoto = new Swiper(el, {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                lazy: {
                    loadPrevNext: true
                }
            });
        });

    }());

    // swiper kontakty-pobočky
    //========================
    (function () {
        let swiperSelector = document.querySelector('.JS-swiper-kontakty-fotogalerie');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperKontaktFoto = new Swiper(swiperSelector, {
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            lazy: {
                loadPrevNext: true
            },
            autoplay: true,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                650: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                767: {
                    slidesPerView: 3,
                    spaceBetween: 10
                }
            }
        });
    }());

    // swiper index
    //=============
    (function () {
        let swiperSelector = document.querySelector('.JS-index-slider-swiper');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperIndex = new Swiper(swiperSelector, {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }());



    // swiper patička - inzerce
    //=========================
    (function () {
        let swiperSelector = document.querySelector('.JS-footer-inzerce');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        if(getComputedStyle(swiperSelector.parentElement, null).getPropertyValue('display') === "none")
            return;

        let swiperInzerce = new Swiper(swiperSelector, {
            autoplay: true,
            centerInsufficientSlides: true,
            lazy:  {
                loadPrevNext: true
            },
            slidesPerView: 5,
            spaceBetween: 40,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                767: {
                    slidesPerView: 4,
                    spaceBetween: 10
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 40,
                }
            }
        });
    }());

    // swiper developerské projekty
    //=============================
    (function () {
        let swiperSelector = document.querySelectorAll('.JS-swiper-projekty');
        swiperSelector.forEach(swiper => {
            new Swiper(swiper, {
                loop: true,
                lazy:  {
                    loadPrevNext: true
                },
                slidesPerView: 5,
                spaceBetween: 10,
                breakpoints: {
                    320: {
                        slidesPerView: 2
                    },
                    425: {
                        slidesPerView: 3
                    },
                    768: {
                        slidesPerView: 4
                    },
                    980: {
                        slidesPerView: 5
                    }
                }
            });
        });
    }());
});